// src/components/productDetail/TextBlock.tsx
import React from 'react';
import './TextBlock.css';

interface TextBlockProps {
    title: string;
    content: string;
    alignment?: 'left' | 'center';
}

export const TextBlock: React.FC<TextBlockProps> = ({
    title,
    content,
    alignment = 'left'
}) => {
    return (
        <div className={`prdth-text-block prdth-align-${alignment}`}>
            <h3 className="prdth-text-title">{title}</h3>
            <div
                className="prdth-text-content"
                dangerouslySetInnerHTML={{ __html: content }}
            />
        </div>
    );
};